import { createSSRApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'

// Performance monitoring
if (typeof window !== 'undefined') {
  if ('performance' in window) {
    window.addEventListener('load', () => {
      const perfData = performance.getEntriesByType('navigation')[0]
      console.log('Page load time:', perfData.loadEventEnd - perfData.loadEventStart, 'ms')
    })
  }
}

export function createApp() {
  const app = createSSRApp(App)
  const pinia = createPinia()

  app.use(pinia)

  // Hydrate Pinia state from SSR AFTER registering with app
  if (typeof window !== 'undefined' && window.__PINIA_INITIAL_STATE__) {
    pinia.state.value = window.__PINIA_INITIAL_STATE__
  }

  return { app, pinia }
}
